import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "../../static/css/App.css";
import { Container, Button, Row, Col, Modal, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../static/css/customerTable.css";
import moment from "moment";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar, gridClasses } from "@mui/x-data-grid";
import { showConfirm } from "react-confirm-prompt";
import DynamicBreadcrumb from "../header/breadcrumb";
import branchApi from "../../services/branchapi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import BranchDetails from "./branchDetail";

library.add(fas);
const AllBranches = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [totalBranch, setTotalBranch] = useState(0);
  const [refreshTable, setRefreshTable] = useState(false);
  const [sortModel, setSortModel] = useState([]);
  const [filterModel, setFilterModel] = useState({ items: [] });
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 15,
  });
  const [openModal, setOpenModal] = useState(false);
  const [notesText, setNotesText] = useState("Enter Reason");
  const [errors, setErrors] = useState({});
  const [closeNotes, setCloseNotes] = useState("");
  const [invDetailModal, setInvDetailModal] = useState(false);
  const [branchId, setBranchId] = useState(null);
  const [branchStatus, setBranchStatus] = useState(null);
  const navigate = useNavigate();

  const pathArray = [
    {
      name: "Branchs List",
      url: null,
    },
  ];

  const fetchBranchs = useCallback(async () => {
    setLoading(true);
    try {
      const { page, pageSize } = paginationModel;
      const data = await branchApi.getAllBranches({
        limit: pageSize,
        page,
        sortModel,
        filterModel,
      });

      const formattedRows = data.data.result.map((brch) => ({
        id: brch.branchId,
        code: brch.code,
        created_at: moment(brch.created_at).format("YYYY/MM/DD kk:mm:ss"),
        name: brch.branchName,
        mobile: brch.phone,
        email: brch.email,
        area: brch.areaName,
        status: brch.status,
        branchType: brch.branchType,
      }));
      setRows(formattedRows);
      setTotalBranch(data.data.totalRecords[0].total_records || 0);
    } catch (error) {
      console.error("Failed to fetch Branch:", error);
    } finally {
      setLoading(false);
    }
  }, [paginationModel, sortModel, filterModel, refreshTable]);

  useEffect(() => {
    fetchBranchs();
  }, [fetchBranchs]);

  const handleStatusClick = (branchId, status) => {
    const sureTxt =
      status === 1
        ? "Are you sure to change status to inactive?"
        : "Are you sure to change status to active?";
    const decTxt =
      status === 1
        ? "This will inactivate the branch"
        : "This will activate the branch";
    showConfirm(sureTxt, {
      description: decTxt,
      type: "info",
    }).then((answer) => {
      if (answer) {
        setBranchId(branchId);
        setBranchStatus(status);
        if (status !== 1) {
          submitUpdateDetails(branchId, status);
        } else {
          setOpenModal(true);
        }
      }
    });
  };

  const columns = [
    {
      field: "sno",
      headerName: "S NO",
      width: 35,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        // server pagination -> serial number should continue across pages
        const indexInPage = params.api.getRowIndexRelativeToVisibleRows(params.id);
        return paginationModel.page * paginationModel.pageSize + indexInPage + 1;
      },
    },
    { field: "created_at", headerName: "Created ON", width: 130, },
    { field: "name", headerName: "Branch Name", flex: 1 },
    { field: "area", headerName: "Area Name", flex: 1, sortable: false },
    {
      field: "contact",
      headerName: "Mobile / Email",
      flex: 1.2,
      sortable: false,
      renderCell: (params) => (
        <div style={{ lineHeight: 1.2 }}>
          <div className="fw-semibold">{params.row.mobile || "-"}</div>
          <div className="text-secondary" style={{ fontSize: 12 }}>
            {params.row.email || "-"}
          </div>
        </div>
      ),
    },

    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: (params) => (
        <Row>
          <Col key={params.id + "-status"} className={"ms-2 p-2 me-2 d-grid gap-2"}>
            <button
              onClick={() => handleStatusClick(params.id, parseInt(params.value))}
              className={`btn ${params.value === 1 ? "btn-danger" : "btn-secondary"
                } custom-status-button`}
              style={{ outline: "none", boxShadow: "none" }}
            >
              {params.value === 1 ? "Active" : "Inactive"}
            </button>
          </Col>
        </Row>
      ),
    },

    {
      field: "action",
      headerName: "Action",
      disableClickEventBubbling: true,
      flex: 1,
      renderCell: (row) => (
        <div className="d-flex gap-2">
          <Button className={"p-2 me-2 "} size="sm" onClick={() => openModelDetail(row)}>
            <FontAwesomeIcon icon="fa-solid fa-eye" size="sm" style={{ color: "black" }} /> View
          </Button>

          {Number(row.row.branchType) === 2 && (
            <Button
              className={"p-2 me-2 "}
              size="sm"
              variant="success"
              onClick={() => navigate(`/admin/branch/${row.id}/zones`)}
            >
              <FontAwesomeIcon icon="fa-solid fa-map-location-dot" size="sm" style={{ color: "black" }} /> Zones
            </Button>
          )}
        </div>
      ),
    },
  ];


  const validateCancelForm = () => {
    const newErrors = {};
    if (!closeNotes) newErrors.closeNotes = "Notes is required";
    return newErrors;
  };

  const handleInactivate = async (event) => {
    event.preventDefault();
    const formErrors = validateCancelForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      setErrors({});
      try {
        submitUpdateDetails(branchId, branchStatus, closeNotes);
      } catch (error) {
        setErrors({ common: "Update Failed" });
      }
    }
  };

  const submitUpdateDetails = async (branchId, status, notes = null) => {
    try {
      let sendStatus = status === 1 ? 2 : 1;
      let params = {
        action: "status",
        status: sendStatus,
        branchId: branchId,
        reason: notes,
      };

      const resp = await branchApi.updateBranchStatus(params);
      if (resp) {
        const message = resp.message || "Branch status updated successfully";
        showConfirm("Success", {
          description: message,
          type: "Success",
          hideCancel: true,
        }).then(() => {
          setRefreshTable(!refreshTable);
          setOpenModal(false);
        });
      } else {
        const message = "Process failed, kindly try again later!";
        showConfirm("Oops!", {
          description: message,
          type: "warning",
          hideCancel: true,
        }).then(() => {
          setRefreshTable(!refreshTable);
          setOpenModal(false);
        });
      }
      handleClose();
    } catch (error) {
      showConfirm("Oops!", {
        description: "Process failed, kindly try again later!",
        type: "warning",
        hideCancel: true,
      });
      handleClose();
    }
  };

  const setReason = (e) => {
    setCloseNotes(e.target.value);
  };

  const handleClose = () => {
    setOpenModal(false);
    setNotesText("Enter Reason");
  };


  const openModelDetail = (row) => {
    setBranchId(row.id);
    setBranchStatus(row.status);
    setInvDetailModal(true);
  };

  const hideViewDetailModal = () => {
    setBranchId(null);
    setInvDetailModal(false);
  };

  return (
    <Container className="mt-4 mb-4">
      <DynamicBreadcrumb pathArray={pathArray} />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>ALL Branchs</h5>
      </div>

      <Box>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowHeight={() => "auto"}
          rowsPerPageOptions={[5, 10, 20]}
          paginationMode="server"
          rowCount={totalBranch}
          loading={loading}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          sortingMode="server"
          filterMode="server"
          onSortModelChange={setSortModel}
          onFilterModelChange={setFilterModel}
          autosizeOptions={{
            columns: ["mobile", "branchName", "status"],
            includeOutliers: true,
            includeHeaders: false,
          }}
          slots={{
            toolbar: GridToolbar,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              printOptions: { disableToolbarButton: true },
              csvOptions: { disableToolbarButton: true },
            },
          }}
          onRowSelectionModelChange={(row) => {
            setRowSelectionModel(row);
          }}
          rowSelectionModel={rowSelectionModel}
          sx={{
            [`& .${gridClasses.cell}`]: {
              py: 0.5,
            },
          }}
        />
      </Box>

      {invDetailModal && (
        <BranchDetails
          invoiceId={branchId}
          invModal={invDetailModal}
          change={hideViewDetailModal}
        />
      )}

      <Modal show={openModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Enter Reason</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="cancelForm">
            <Form.Group className="mb-3" controlId="closeNotes">
              <Form.Label>Enter inactivate reason</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={closeNotes}
                onChange={setReason}
                isInvalid={!!errors.closeNotes}
              />
            </Form.Group>
            <Form.Control.Feedback type="invalid">
              {errors.closeNotes}
            </Form.Control.Feedback>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleInactivate}>
            Submit Reason
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};


export default AllBranches;
